export const countryData = [
    { country: 'Afghanistan', abbreviation: 'AF', region: 'Asia' },
    { country: 'Albania', abbreviation: 'AL', region: 'Europe' },
    { country: 'Algeria', abbreviation: 'DZ', region: 'Africa' },
    { country: 'Andorra', abbreviation: 'AD', region: 'Europe' },
    { country: 'Angola', abbreviation: 'AO', region: 'Africa' },
    { country: 'Antigua and Barbuda', abbreviation: 'AG', region: 'Americas' },
    { country: 'Argentina', abbreviation: 'AR', region: 'Americas' },
    { country: 'Armenia', abbreviation: 'AM', region: 'Asia' },
    { country: 'Australia', abbreviation: 'AU', region: 'Oceania' },
    { country: 'Austria', abbreviation: 'AT', region: 'Europe' },
    { country: 'Azerbaijan', abbreviation: 'AZ', region: 'Asia' },
    { country: 'Bahamas', abbreviation: 'BS', region: 'Americas' },
    { country: 'Bahrain', abbreviation: 'BH', region: 'Asia' },
    { country: 'Bangladesh', abbreviation: 'BD', region: 'Asia' },
    { country: 'Barbados', abbreviation: 'BB', region: 'Americas' },
    { country: 'Belarus', abbreviation: 'BY', region: 'Europe' },
    { country: 'Belgium', abbreviation: 'BE', region: 'Europe' },
    { country: 'Belize', abbreviation: 'BZ', region: 'Americas' },
    { country: 'Benin', abbreviation: 'BJ', region: 'Africa' },
    { country: 'Bhutan', abbreviation: 'BT', region: 'Asia' },
    { country: 'Bolivia', abbreviation: 'BO', region: 'Americas' },
    { country: 'Bosnia and Herzegovina', abbreviation: 'BA', region: 'Europe' },
    { country: 'Botswana', abbreviation: 'BW', region: 'Africa' },
    { country: 'Brazil', abbreviation: 'BR', region: 'Americas' },
    { country: 'Brunei', abbreviation: 'BN', region: 'Asia' },
    { country: 'Bulgaria', abbreviation: 'BG', region: 'Europe' },
    { country: 'Burkina Faso', abbreviation: 'BF', region: 'Africa' },
    { country: 'Burundi', abbreviation: 'BI', region: 'Africa' },
    { country: 'Cabo Verde', abbreviation: 'CV', region: 'Africa' },
    { country: 'Cambodia', abbreviation: 'KH', region: 'Asia' },
    { country: 'Cameroon', abbreviation: 'CM', region: 'Africa' },
    { country: 'Canada', abbreviation: 'CA', region: 'Americas' },
    { country: 'Central African Republic', abbreviation: 'CF', region: 'Africa' },
    { country: 'Chad', abbreviation: 'TD', region: 'Africa' },
    { country: 'Chile', abbreviation: 'CL', region: 'Americas' },
    { country: 'China', abbreviation: 'CN', region: 'Asia' },
    { country: 'Colombia', abbreviation: 'CO', region: 'Americas' },
    { country: 'Comoros', abbreviation: 'KM', region: 'Africa' },
    { country: 'Congo', abbreviation: 'CG', region: 'Africa' },
    { country: 'Costa Rica', abbreviation: 'CR', region: 'Americas' },
    { country: 'Croatia', abbreviation: 'HR', region: 'Europe' },
    { country: 'Cuba', abbreviation: 'CU', region: 'Americas' },
    { country: 'Cyprus', abbreviation: 'CY', region: 'Asia' },
    { country: 'Czechia', abbreviation: 'CZ', region: 'Europe' },
    { country: 'DR Congo', abbreviation: 'CD', region: 'Africa' },
    { country: 'Denmark', abbreviation: 'DK', region: 'Europe' },
    { country: 'Djibouti', abbreviation: 'DJ', region: 'Africa' },
    { country: 'Dominica', abbreviation: 'DM', region: 'Americas' },
    { country: 'Dominican Republic', abbreviation: 'DO', region: 'Americas' },
    { country: 'Ecuador', abbreviation: 'EC', region: 'Americas' },
    { country: 'Egypt', abbreviation: 'EG', region: 'Africa' },
    { country: 'El Salvador', abbreviation: 'SV', region: 'Americas' },
    { country: 'Equatorial Guinea', abbreviation: 'GQ', region: 'Africa' },
    { country: 'Eritrea', abbreviation: 'ER', region: 'Africa' },
    { country: 'Estonia', abbreviation: 'EE', region: 'Europe' },
    { country: 'Eswatini', abbreviation: 'SZ', region: 'Africa' },
    { country: 'Ethiopia', abbreviation: 'ET', region: 'Africa' },
    { country: 'Fiji', abbreviation: 'FJ', region: 'Oceania' },
    { country: 'Finland', abbreviation: 'FI', region: 'Europe' },
    { country: 'France', abbreviation: 'FR', region: 'Europe' },
    { country: 'Gabon', abbreviation: 'GA', region: 'Africa' },
    { country: 'Gambia', abbreviation: 'GM', region: 'Africa' },
    { country: 'Georgia', abbreviation: 'GE', region: 'Asia' },
    { country: 'Germany', abbreviation: 'DE', region: 'Europe' },
    { country: 'Ghana', abbreviation: 'GH', region: 'Africa' },
    { country: 'Greece', abbreviation: 'GR', region: 'Europe' },
    { country: 'Grenada', abbreviation: 'GD', region: 'Americas' },
    { country: 'Guatemala', abbreviation: 'GT', region: 'Americas' },
    { country: 'Guinea', abbreviation: 'GN', region: 'Africa' },
    { country: 'Guinea-Bissau', abbreviation: 'GW', region: 'Africa' },
    { country: 'Guyana', abbreviation: 'GY', region: 'Americas' },
    { country: 'Haiti', abbreviation: 'HT', region: 'Americas' },
    { country: 'Holy See', abbreviation: 'VA', region: 'Europe' },
    { country: 'Honduras', abbreviation: 'HN', region: 'Americas' },
    { country: 'Hungary', abbreviation: 'HU', region: 'Europe' },
    { country: 'Iceland', abbreviation: 'IS', region: 'Europe' },
    { country: 'India', abbreviation: 'IN', region: 'Asia' },
    { country: 'Indonesia', abbreviation: 'ID', region: 'Asia' },
    { country: 'Iran', abbreviation: 'IR', region: 'Asia' },
    { country: 'Iraq', abbreviation: 'IQ', region: 'Asia' },
    { country: 'Ireland', abbreviation: 'IE', region: 'Europe' },
    { country: 'Israel', abbreviation: 'IL', region: 'Asia' },
    { country: 'Italy', abbreviation: 'IT', region: 'Europe' },
    { country: 'Jamaica', abbreviation: 'JM', region: 'Americas' },
    { country: 'Japan', abbreviation: 'JP', region: 'Asia' },
    { country: 'Jordan', abbreviation: 'JO', region: 'Asia' },
    { country: 'Kazakhstan', abbreviation: 'KZ', region: 'Asia' },
    { country: 'Kenya', abbreviation: 'KE', region: 'Africa' },
    { country: 'Kiribati', abbreviation: 'KI', region: 'Oceania' },
    { country: 'Kuwait', abbreviation: 'KW', region: 'Asia' },
    { country: 'Kyrgyzstan', abbreviation: 'KG', region: 'Asia' },
    { country: 'Laos', abbreviation: 'LA', region: 'Asia' },
    { country: 'Latvia', abbreviation: 'LV', region: 'Europe' },
    { country: 'Lebanon', abbreviation: 'LB', region: 'Asia' },
    { country: 'Lesotho', abbreviation: 'LS', region: 'Africa' },
    { country: 'Liberia', abbreviation: 'LR', region: 'Africa' },
    { country: 'Libya', abbreviation: 'LY', region: 'Africa' },
    { country: 'Liechtenstein', abbreviation: 'LI', region: 'Europe' },
    { country: 'Lithuania', abbreviation: 'LT', region: 'Europe' },
    { country: 'Luxembourg', abbreviation: 'LU', region: 'Europe' },
    { country: 'Madagascar', abbreviation: 'MG', region: 'Africa' },
    { country: 'Malawi', abbreviation: 'MW', region: 'Africa' },
    { country: 'Malaysia', abbreviation: 'MY', region: 'Asia' },
    { country: 'Maldives', abbreviation: 'MV', region: 'Asia' },
    { country: 'Mali', abbreviation: 'ML', region: 'Africa' },
    { country: 'Malta', abbreviation: 'MT', region: 'Europe' },
    { country: 'Marshall Islands', abbreviation: 'MH', region: 'Oceania' },
    { country: 'Mauritania', abbreviation: 'MR', region: 'Africa' },
    { country: 'Mauritius', abbreviation: 'MU', region: 'Africa' },
    { country: 'Mexico', abbreviation: 'MX', region: 'Americas' },
    { country: 'Micronesia', abbreviation: 'FM', region: 'Oceania' },
    { country: 'Moldova', abbreviation: 'MD', region: 'Europe' },
    { country: 'Monaco', abbreviation: 'MC', region: 'Europe' },
    { country: 'Mongolia', abbreviation: 'MN', region: 'Asia' },
    { country: 'Montenegro', abbreviation: 'ME', region: 'Europe' },
    { country: 'Morocco', abbreviation: 'MA', region: 'Africa' },
    { country: 'Mozambique', abbreviation: 'MZ', region: 'Africa' },
    { country: 'Myanmar', abbreviation: 'MM', region: 'Asia' },
    { country: 'Namibia', abbreviation: 'NA', region: 'Africa' },
    { country: 'Nauru', abbreviation: 'NR', region: 'Oceania' },
    { country: 'Nepal', abbreviation: 'NP', region: 'Asia' },
    { country: 'Netherlands', abbreviation: 'NL', region: 'Europe' },
    { country: 'New Zealand', abbreviation: 'NZ', region: 'Oceania' },
    { country: 'Nicaragua', abbreviation: 'NI', region: 'Americas' },
    { country: 'Niger', abbreviation: 'NE', region: 'Africa' },
    { country: 'Nigeria', abbreviation: 'NG', region: 'Africa' },
    { country: 'North Korea', abbreviation: 'KP', region: 'Asia' },
    { country: 'North Macedonia', abbreviation: 'MK', region: 'Europe' },
    { country: 'Norway', abbreviation: 'NO', region: 'Europe' },
    { country: 'Oman', abbreviation: 'OM', region: 'Asia' },
    { country: 'Pakistan', abbreviation: 'PK', region: 'Asia' },
    { country: 'Palau', abbreviation: 'PW', region: 'Oceania' },
    { country: 'Palestine', abbreviation: 'PS', region: 'Asia' },
    { country: 'Panama', abbreviation: 'PA', region: 'Americas' },
    { country: 'Papua New Guinea', abbreviation: 'PG', region: 'Oceania' },
    { country: 'Paraguay', abbreviation: 'PY', region: 'Americas' },
    { country: 'Peru', abbreviation: 'PE', region: 'Americas' },
    { country: 'Philippines', abbreviation: 'PH', region: 'Asia' },
    { country: 'Poland', abbreviation: 'PL', region: 'Europe' },
    { country: 'Portugal', abbreviation: 'PT', region: 'Europe' },
    { country: 'Qatar', abbreviation: 'QA', region: 'Asia' },
    { country: 'Romania', abbreviation: 'RO', region: 'Europe' },
    { country: 'Russia', abbreviation: 'RU', region: 'Europe' },
    { country: 'Rwanda', abbreviation: 'RW', region: 'Africa' },
    { country: 'Saint Kitts and Nevis', abbreviation: 'KN', region: 'Americas' },
    { country: 'Saint Lucia', abbreviation: 'LC', region: 'Americas' },
    { country: 'Saint Vincent', abbreviation: 'VC', region: 'Americas' },
    { country: 'Samoa', abbreviation: 'WS', region: 'Oceania' },
    { country: 'San Marino', abbreviation: 'SM', region: 'Europe' },
    { country: 'Sao Tome and Principe', abbreviation: 'ST', region: 'Africa' },
    { country: 'Saudi Arabia', abbreviation: 'SA', region: 'Asia' },
    { country: 'Senegal', abbreviation: 'SN', region: 'Africa' },
    { country: 'Serbia', abbreviation: 'RS', region: 'Europe' },
    { country: 'Seychelles', abbreviation: 'SC', region: 'Africa' },
    { country: 'Sierra Leone', abbreviation: 'SL', region: 'Africa' },
    { country: 'Singapore', abbreviation: 'SG', region: 'Asia' },
    { country: 'Slovakia', abbreviation: 'SK', region: 'Europe' },
    { country: 'Slovenia', abbreviation: 'SI', region: 'Europe' },
    { country: 'Solomon Islands', abbreviation: 'SB', region: 'Oceania' },
    { country: 'Somalia', abbreviation: 'SO', region: 'Africa' },
    { country: 'South Africa', abbreviation: 'ZA', region: 'Africa' },
    { country: 'South Korea', abbreviation: 'KR', region: 'Asia' },
    { country: 'South Sudan', abbreviation: 'SS', region: 'Africa' },
    { country: 'Spain', abbreviation: 'ES', region: 'Europe' },
    { country: 'Sri Lanka', abbreviation: 'LK', region: 'Asia' },
    { country: 'Sudan', abbreviation: 'SD', region: 'Africa' },
    { country: 'Suriname', abbreviation: 'SR', region: 'Americas' },
    { country: 'Sweden', abbreviation: 'SE', region: 'Europe' },
    { country: 'Switzerland', abbreviation: 'CH', region: 'Europe' },
    { country: 'Syria', abbreviation: 'SY', region: 'Asia' },
    { country: 'Tajikistan', abbreviation: 'TJ', region: 'Asia' },
    { country: 'Tanzania', abbreviation: 'TZ', region: 'Africa' },
    { country: 'Thailand', abbreviation: 'TH', region: 'Asia' },
    { country: 'Timor-Leste', abbreviation: 'TL', region: 'Asia' },
    { country: 'Togo', abbreviation: 'TG', region: 'Africa' },
    { country: 'Tonga', abbreviation: 'TO', region: 'Oceania' },
    { country: 'Trinidad and Tobago', abbreviation: 'TT', region: 'Americas' },
    { country: 'Tunisia', abbreviation: 'TN', region: 'Africa' },
    { country: 'Turkey', abbreviation: 'TR', region: 'Asia' },
    { country: 'Turkmenistan', abbreviation: 'TM', region: 'Asia' },
    { country: 'Tuvalu', abbreviation: 'TV', region: 'Oceania' },
    { country: 'Uganda', abbreviation: 'UG', region: 'Africa' },
    { country: 'Ukraine', abbreviation: 'UA', region: 'Europe' },
    { country: 'United Arab Emirates', abbreviation: 'AE', region: 'Asia' },
    { country: 'United Kingdom', abbreviation: 'GB', region: 'Europe' },
    { country: 'United States', abbreviation: 'US', region: 'Americas' },
    { country: 'Uruguay', abbreviation: 'UY', region: 'Americas' },
    { country: 'Uzbekistan', abbreviation: 'UZ', region: 'Asia' },
    { country: 'Vanuatu', abbreviation: 'VU', region: 'Oceania' },
    { country: 'Venezuela', abbreviation: 'VE', region: 'Americas' },
    { country: 'Vietnam', abbreviation: 'VN', region: 'Asia' },
    { country: 'Yemen', abbreviation: 'YE', region: 'Asia' },
    { country: 'Zambia', abbreviation: 'ZM', region: 'Africa' },
    { country: 'Zimbabwe', abbreviation: 'ZW', region: 'Africa' }
];

// Deduplicated list of regions
export const regionOptions = Array.from(new Set(countryData.map(c => c.region)))
    .sort()
    .map(region => ({ value: region, label: region }));

// Generate country options (optionally filterable by region)
export const getCountryOptions = (region = null) => {
    let filtered = countryData;
    if (region) {
        filtered = countryData.filter(c => c.region === region);
    }
    return filtered.sort((a,b) => a.country.localeCompare(b.country)).map(c => ({
        value: c.country,
        label: c.country
    }));
};
